import { RecategorizeQueueRequest } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteRecategorizeQueueRequest
  extends BaseHttpService<RecategorizeQueueRequest.Model>
  implements RecategorizeQueueRequest
{
  async post(body: RecategorizeQueueRequest.Body): Promise<RecategorizeQueueRequest.Model> {
    return await this.request('post', body);
  }
}
